
import { put} from 'redux-saga/effects';
import { UIAction } from '../actions';


export function* uiEffect(message, loaderStatus, isToast=false) {
    console.log('message-----------', message)
    yield put(UIAction.showMessages(message));
    yield put(UIAction.showLoading(loaderStatus));
}